const CHANNEL_NAME = 'ethernal-auth-channel';
const FORCE_SIGNOUT_MESSAGE = 'FORCE_SIGNOUT_OTHER_TABS';

let broadcastChannel: BroadcastChannel | null = null;
let currentTabId: string | null = null;

export const initTabCommunication = (): string => {
  if (typeof BroadcastChannel === 'undefined') {
    console.warn('[TabCommunication] BroadcastChannel not supported');
    return '';
  }

  currentTabId = `tab-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

  if (!broadcastChannel) {
    broadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    console.log('[TabCommunication] Channel initialized for tab:', currentTabId);
  }

  return currentTabId;
};

export const sendForceSignout = (sourceTabId: string): void => {
  if (!broadcastChannel) {
    console.warn('[TabCommunication] Channel not initialized');
    return;
  }

  console.log('[TabCommunication] Broadcasting FORCE_SIGNOUT from tab:', sourceTabId);

  broadcastChannel.postMessage({
    type: FORCE_SIGNOUT_MESSAGE,
    sourceTabId,
    timestamp: Date.now()
  });
};

export const listenForSignout = (onSignout: () => void): (() => void) => {
  if (!broadcastChannel || !currentTabId) {
    console.warn('[TabCommunication] Channel or tabId not initialized');
    return () => {};
  }

  const handleMessage = (event: MessageEvent) => {
    const { type, sourceTabId } = event.data;

    if (type === FORCE_SIGNOUT_MESSAGE) {
      if (sourceTabId === currentTabId) {
        console.log('[TabCommunication] Ignoring self-signout message');
        return;
      }

      console.log('[TabCommunication] Received FORCE_SIGNOUT from:', sourceTabId);
      console.log('[TabCommunication] Current tab will sign out:', currentTabId);

      onSignout();
    }
  };

  broadcastChannel.addEventListener('message', handleMessage);

  return () => {
    if (broadcastChannel) {
      broadcastChannel.removeEventListener('message', handleMessage);
    }
  };
};

export const cleanupTabCommunication = (): void => {
  if (broadcastChannel) {
    console.log('[TabCommunication] Cleaning up channel for tab:', currentTabId);
    broadcastChannel.close();
    broadcastChannel = null;
  }
  currentTabId = null;
};

export const getCurrentTabId = (): string | null => currentTabId;
